<form
  class="otp-form"
  (ngSubmit)="onSubmit()"
>
  <div class="otp-header">
    @if (!otpRequest() && isLoading()) {
      {{ 'otp.is_in_progress' | translate }}

    } @else if (otpRequest().isExisting) {
      @let otpDestination = otpRequest().otpDestination;
      @if (otpRequest().otpDestinationType === OtpDestinationType.Email) {
        <span [innerHTML]="'otp.otp_header_email_existing' | translate:{otpDestination}"></span>
      } @else if (otpRequest().otpDestinationType === OtpDestinationType.Telegram) {
        <span [innerHTML]="'otp.otp_header_telegram_existing' | translate:{otpDestination}"></span>
      } @else {
        <span [innerHTML]="'otp.otp_header_sms_existing' | translate:{otpDestination}"></span>
      }
    } @else {

      @let otpDestination = otpRequest().otpDestination;
      @if (otpRequest().otpDestinationType === OtpDestinationType.Email) {
        <span [innerHTML]="'otp.otp_header_email' | translate:{otpDestination}"></span>
      } @else if (otpRequest().otpDestinationType === OtpDestinationType.Telegram) {
        <span [innerHTML]="'otp.otp_header_telegram' | translate:{otpDestination}"></span>
      } @else {
        <span [innerHTML]="'otp.otp_header_sms' | translate:{otpDestination}"></span>
      }
    }
  </div>

  <div class="otp-inputs">
    @for (otpDigit of otpDigitsFormArray().controls; track otpDigit) {
      <input
        class="g-form-input otp-input"
        [class.g-form-input-invalid]="isControlInvalid(otpDigitsFormArray().at($index))"
        [formControl]="otpDigitsFormArray().at($index)"
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        [maxlength]="OTP_LENGTH"
        digitsOnlyInput
        selectOnFocus
        [appAutofocus]="$index === 0"
        (input)="onInputEvent($index, $any($event))"
        (paste)="onPaste($index, $event)"
        (keyup.backspace)="onBackspace($index)"
        (keydown.arrowRight)="focusOtpInput($index + 1)"
        (keydown.arrowLeft)="focusOtpInput($index - 1)"
        #otpInput
      >
    }
  </div>

  @if (isControlInvalid(otpDigitsFormArray())) {
    <div class="g-form-control-error">
      {{ 'global.required_field' | translate }}
    </div>
  }

  @if (error()) {
    <div class="g-form-error otp-error">
      {{ error() }}
    </div>
  }

  <tc-button
    class="otp-submit"
    [isLoading]="isLoading()"
    buttonSize="large"
    buttonType="submit"
    type="submit"
  >
    {{ (submitLabel() || 'global.confirm') | translate }}
  </tc-button>

  @if (canResendOtp$ | async) {
    <button
      class="g-main-link resend-otp"
      (click)="onResendOtp()"
      [disabled]="isLoading()"
    >
      {{ 'otp.resend_otp' | translate }}
    </button>
  } @else {
    <div class="resend-otp-left">
      <span class="resend-otp-left-label">{{ 'otp.resend_otp' | translate }}</span>: {{ 'otp.resend_otp_in' | translate }} {{ (nextOtpRetryTimeLeft$ | async) || '...' }} {{ 'otp.resend_otp_min' | translate }}
    </div>
  }
</form>
